<template>
    <div class="flex flex-wrap items-start">
        <div class="bg-white rounded-2xl p-4 mr-8 shadow-2xl mt-4 mb-10">
            <div class="inline-block">
                <div class="float-left text-gray-800 text-3xl mx-3 my-1 font-bold">{{ title }}</div>
            </div>
            <div class="float-right">
                <div class="table text-center">
                    <div class="table-cell px-2 cursor-pointer" @click="sampleReport = true" v-if="tellMeMoreUrl != null">
                        <div class="inline-block sprite-icons-sample heartbeat"></div>
                        <div class="text-xs">Sample Report</div>
                    </div>
                    <div class="table-cell px-2 cursor-pointer" v-if="tellMeMoreUrl != null">
                        <div class="inline-block sprite-icons-more rubberband" @click="toggleHelp()"></div>
                        <div class="text-xs">Tell me more</div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
                <div class="my-3">
                    <slot name="top"></slot>
                </div>
                <slot></slot>
                <div class="my-3" v-if="showFooter">
                    <div class="btn btn-success" @click="submit()">Submit</div>
                    <div class="btn btn-error" @click="clear">Clear</div>
                </div>
        </div>
    
        <div class="bg-white rounded-2xl sm_mr-8 shadow-2xl mt-4 flex-1 p-4 mb-10">
            <div class="text-3xl px-4 font-bold">Results</div>
                <div class="text-error-600 p-4 border-dashed border-red-300 border" v-if="failed">{{ failed }}</div>
                <slot v-else name="results">
                    <div>No results available</div>
                </slot>
        </div>
               

        <m-dialog width="w-full" heading="Report" :show="showReport" v-if="showReport" @close="showReport = false">
            <div class="text-error-600 p-4 border-dashed border-red-300 border" v-if="reportFailed">{{
                    reportFailed
                }}
            </div>
            <m-reportrender v-else :id="reportReference" :merged="true" ref="renderer" :specialType="specialType">
                <p class="text-4xl text-gray-800" v-if="!reportReference">No Report Available</p>
                <template v-slot:left="">
                    <div class="cursor-pointer inline-block mx-1 sprite-icons-back" @click="activeTab = 1"></div>
                    <div class="cursor-pointer inline-block mx-1 sprite-icons-new" @click="reset()"></div>
                </template>
            </m-reportrender>

            <template v-slot:footer>
                <div class="btn btn-primary" @click="showReport = false">Close</div>
            </template>
        </m-dialog>
        <m-dialog :show.sync="tellMeMore.visible" heading="Tell Me More" width="580px">
            <div class="ck-content" v-html="tellMeMore.body"></div>
        </m-dialog>

      <m-dialog :show.sync="sampleReport" heading="Sample Report" width="1024px">
        <object class="w-full border-none bg-loading" style="height: 80vh" :data="'/Sample Report?product=' + tellMeMoreUrl" type="application/pdf">
          <div class="text-2xl text-center mt-4">Cannot render sample PDF.</div>
        </object>
      </m-dialog>
      
    </div>
</template>

<script>
import headerpanel from "./headerpanel.vue";
import Axios from "axios";
import Ajax from "@/js/ajax";
import Share from '@/share.js'
import emailReport from './emailReport.vue'

export default {
    components: {
        'm-headerpanel': headerpanel,
        'm-emailreport': emailReport
    },
    props: {
        specialType: String,
        showFooter: {
            type: Boolean,
            default: true
        },
        title: String,
        active: {
            type: Number,
            default: 0
        },

        reportReference: String,
        reportName: String,

        failed: {
            type: String,
            default: null
        },
        reportFailed: {
            type: String,
            default: null
        },
        showHelp: true,
        tellMeMoreUrl: [String, Number],
        submitText: {
            type: String,
            default: "Submit"
        },
        // 0 HTML, 1 PDF
        reportType: {
            type: Number,
            default: 0
        },
        showReport: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            profile: window.initial,
            tellMeMore: {
                title: '',
                body: 'aa',
                visible: false
            },
            report: false,
            valid: false,
            email: '',
            emailDialog: {
                emails: [],
                name: '',
                message: '',
                visible: false
            },
            printurl: "",
            sampleReport: false,
        };
    },
    methods: {
        submit() {
            this.report = false
            // this.$refs.renderer.clear()
            this.$emit('submit')
        },
        clear() {
            this.report = false
            // this.$refs.renderer.clear()
            this.$emit('clean')
        },
        toggleHelp() {
            Ajax.get(`/tellmemore/${this.tellMeMoreUrl}.html`).then(resp => {
                this.tellMeMore.body = resp
                this.tellMeMore.visible = true
            })
        },
        splitSize(full, short) {
            return this.showHelp ? full : short
        },
        complete() {
            this.$emit("update:active", 1);
            this.$emit("complete");
            // Share.showLoader()

            Axios.get("/home/enquiriesleft").then(resp => {
                this.profile.enquiriesLeft = resp.data;
            });
        },
        error() {
            this.$emit("error");
            Share.hideLoader()
        }
    }
};
</script>
